module.exports = __webpack_public_path__ + "static/media/dheyacareeprice.43ca82b1.png";